<template>
  <ul class="condition-group">
    <li
      v-for="(row, index) in list"
      :key="row._id"
      class="clearfix"
    >
      <label class="fl">{{ index === 0 ? $t('message[1735]') + ':' : $t('message[1747]') + ' ' }}</label>
      <a-form-item class="fl">
        <div
          v-decorator="[`keyVal[${index}]`, {
            rules: [{
              required: true,
              message: $t('message[855]')
            }],
            initialValue: row.keyVal
          }]"
          class="wrap"
        >
          <a-select
            :value="row.keyVal"
            :allow-clear="true"
            class="select1"
            :placeholder="$t('message[855]')"
            :get-popup-container="
              triggerNode => {
                return triggerNode.parentNode || document.body;
              }
            "
            @change="handleChangeType($event, row, index)"
            @dropdownVisibleChange="dropdownVisibleChange($event, row, index)"
          >
            <a-select-option
              v-if="selectChildEmpty"
              key="empty"
              class="empty"
            >
              <i class="iconfont iconicon-test38" />
              {{ $t('message[1748]') }}
            </a-select-option>
            <a-select-option
              v-for="option in row.child"
              :key="option.fieldkey"
              :value="option.fieldkey"
              :class="{ hide: option.chooseed }"
            >
              {{ option.fieldname }}
            </a-select-option>
          </a-select>
        </div>
      </a-form-item>
      <span class="fl equal">=</span>
      <a-form-item class="fl">
        <div
          v-decorator="[`val[${index}]`, {
            rules: [{
              required: true,
              message: $t('message[855]')
            }],
            initialValue: row.val
          }]"
          class="wrap"
        >
          <a-select
            :value="row.val"
            :allow-clear="true"
            class="fl select2"
            :placeholder="$t('message[855]')"
            @change="handleChangeValue($event, row, index)"
          >
            <a-select-option
              v-for="option in row.options"
              :key="option.id"
              :value="option.id"
            >
              {{ option.name }}
            </a-select-option>
          </a-select>
        </div>
      </a-form-item>
      <a
        v-if="index"
        class="del-btn"
        @click="handleDelete(index)"
      >{{ $t('message[962]') }}</a>
    </li>
    <a
      v-if="list.length < 3"
      class="add-btn"
      @click="handleAdd"
    ><i class="iconfont iconicon-test10 fs-ccc" />{{ $t('message[1750]') }}</a>
  </ul>
</template>

<script>
import _ from 'lodash'
export default {
  inject: ['myForm'],
  props: {
    ruleValue: {
      type: [Object, Array],
      default: () => {}
    },
    baseInfoChild: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      list: [],
      selectChildEmpty: false
    }
  },
  watch: {
    ruleValue: {
      handler (val) {
        this.initList()
      },
      deep: true
    }
    /* visible (val) {
      if (val) {
        this.initList()
      }
    } */
  },
  created () {
    this.initList()
  },
  methods: {
    initList () {
      let child = this.baseInfoChild || []
      let { base_info: baseInfo = {} } = this.ruleValue
      this.list = _.reduce(baseInfo, (res, rowVal, k) => {
        let keyVal = k || ''
        // 如果左侧下拉的值，不存在于下拉选项中，置为undefined
        if (!child.find(o => o.fieldkey === keyVal)) {
          keyVal = undefined
        }
        let item = child.find(item => item.fieldkey === keyVal)
        let { fieldtype, options = [], fieldconfig } = item || {}
        if (fieldtype === 'radioinfo_level') {
          options = this.LevelOption(options, fieldconfig)
        }

        // 如果右侧下拉的值，不存在于下拉选项中，置为undefined
        if (!options.find(o => o.id === rowVal)) {
          rowVal = undefined
        }

        let obj = {
          _id: Math.random() * Math.pow(10, 18),
          child,
          options,
          keyVal,
          val: rowVal
        }
        res.push(obj)
        return res
      }, [])
      if (!this.list.length) {
        this.handleAdd()
      }
    },
    handleAdd () {
      let child = this.baseInfoChild || []
      child = child.filter(item => item.fieldtype !== 'radioinfo_payfor')
      child.forEach(item => {
        this.$set(item, 'chooseed', false)
      })
      this.selectChildEmpty = false
      let newObj = {
        _id: Math.random() * Math.pow(10, 18),
        child,
        options: [],
        keyVal: undefined,
        val: undefined
      }

      this.list.push(_.cloneDeep(newObj))
    },
    handleDelete (i) {
      this.clearChoosed()
      this.list.splice(i, 1)
    },
    handleChangeType (val, row, index) {
      if (val === 'empty') {
        val = undefined
        return
      }
      let item = row.child.find(item => item.fieldkey === val)
      let { fieldtype, options = [], fieldconfig } = item || {}
      if (fieldtype === 'radioinfo_level') {
        row.options = this.LevelOption(options, fieldconfig)
      } else {
        row.options = options
      }
      if (!val) {
        this.clearChoosed()
      }

      row.keyVal = val
      row.val = undefined
      this.list.splice(index, 1, row)

      this.myForm.setFieldsValue({
        [`keyVal[${index}]`]: val
      })
    },
    handleChangeValue (val, row, index) {
      row.val = val
      this.list.splice(index, 1, row)

      this.myForm.setFieldsValue({
        [`val[${index}]`]: val
      })
    },
    dropdownVisibleChange (val, row, index) {
      if (val) {
        row.child.forEach(item => {
          let isFind = this.list.find(o => o.keyVal === item.fieldkey)
          if (isFind) {
            this.$set(item, 'chooseed', true)
          }
        })
        if (row.child.filter(item => !item.chooseed).length === 0) {
          this.selectChildEmpty = true
        }
      }
    },
    clearChoosed () {
      this.selectChildEmpty = false
      this.list.forEach(row => {
        row.child.forEach(item => {
          this.$set(item, 'chooseed', false)
        })
      })
    },
    LevelOption (options, fieldconfig) {
      const { type } = fieldconfig
      let arr = []

      if (type === 1) {
        arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G']
      } else if (type === 2) {
        let str = this.$t('message[1444]')
        arr = str.split(',')
        // arr = ['一星', '二星', '三星', '四星', '五星', '六星', '七星']
      }

      options.forEach((item, index) => {
        arr.forEach((code, i) => {
          if (index === i) {
            item.name = code
          }
        })
      })

      return options
    },
    checkRuleGroup () {
      let keyVals = this.list.map(item => item.keyVal || undefined)
      let vals = this.list.map(item => item.val || undefined)
      this.myForm.setFieldsValue({
        'keyVal': keyVals,
        'val': vals
      })
      this.myForm.validateFields(['keyVal', 'val'], (err) => {
        if (!err) {
          let list = _.cloneDeep(this.list)
          let result = _.reduce(list, (res, item, k) => {
            if (item.keyVal) {
              res['base_info'] = res['base_info'] || {}
              res['base_info'][item.keyVal] = item.val
            }
            return res
          }, {})
          this.$emit('change', result)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.condition-group ::v-deep {
  padding-bottom: 24px;
  margin-bottom: 16px;
  border-bottom: solid 1px #EBEBEB;
  .hide {
    display: none;
  }
  .empty {
    text-align: center;
    color: #b3b3b3;
    .iconfont {
      display: block;
      margin: 10px 0 8px;
      text-align: center;
      color: #D6D6D6;
      font-size: 24px;
    }
    &.ant-select-dropdown-menu-item,
    &.ant-select-dropdown-menu-item:hover {
      background: none;
    }
    .ant-select-selected-icon {
      display: none;
    }
  }
  .ant-select-dropdown-menu-item-disabled:hover {
    background: none;
  }
}
li {
  > label {
    width: 120px;
    padding-right: 22px;
    line-height: 32px;
    text-align: right;
    color: #333;
  }
  ::v-deep .ant-form-item-control-wrapper {
    padding-left: 0;
  }
}

.select1 ::v-deep {
  width: 136px;
  .ant-select-selection {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
}
.select2 ::v-deep {
  width: 166px;
  .ant-select-selection {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}
.equal {
  width: 40px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border: 1px solid #d6d6d6;
  border-right: 0;
  border-left: 0;
}
.del-btn {
  margin-left: 16px;
}
.add-btn {
  margin-left: 120px;
  .iconfont {
    margin-right: 4px;
  }
}
</style>
